<template>
    <div class="suppliers_menu">
        <div class="row">
            <div class="col-sm-12 p-lr-0-sm">
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-xl-4 col-xxl-3 col-sm-12 col-12 mb-4 p-lr-0-sm">
                        <div class="card">
                            <div class="card-body p-3">
                                <div class="col-sm-12 dis-flex flex-sb p-0 mb-3">
                                    <div class="dis-flex flex-m">
                                        <div class="sidebar-cat-icon dis-flex flex-m flex-c">
                                            <div class="brand_logo">
                                                <img src="https://smiltenespiens.lv/wp-content/themes/SmiltenesPiensWP/assets/images/header/smiltene-logo-dark.png" alt="">
                                            </div>
                                        </div>
                                        <label class="label_name m-0">Smiltene</label>
                                    </div>
                                    <div class="btn small-form-btn bar-code pointer mt-0"><i class="uis uis-search fs-12"></i></div>
                                </div>
                                <div class="col-sm-12 p-0">
                                    <div class="form-control bor-dash text-center">
                                        <p>Raw materials supplier</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-xl-4 col-xxl-3 col-sm-12 col-12 mb-4 p-lr-0-sm">
                        <div class="card">
                            <div class="card-body p-3">
                                <div class="col-sm-12 dis-flex flex-sb p-0 mb-3">
                                    <div class="dis-flex flex-m">
                                        <div class="sidebar-cat-icon dis-flex flex-m flex-c">
                                            <div class="brand_logo">
                                                <img src="https://mlekpol.com.pl/wp-content/uploads/2022/07/Logo_Mlekpol_2022-1.png" alt="">
                                            </div>
                                        </div>
                                        <label class="label_name m-0">MlekPol</label>
                                    </div>
                                    <div class="btn small-form-btn bar-code pointer mt-0"><i class="uis uis-search fs-12"></i></div>
                                </div>
                                <div class="col-sm-12 p-0">
                                    <div class="form-control bor-dash text-center">
                                        <p>Raw materials supplier</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-xl-4 col-xxl-3 col-sm-12 col-12 mb-4 p-lr-0-sm">
                        <div class="card">
                            <div class="card-body p-3">
                                <div class="col-sm-12 dis-flex flex-sb p-0 mb-3">
                                    <div class="dis-flex flex-m">
                                        <div class="sidebar-cat-icon dis-flex flex-m flex-c">
                                            <div class="brand_logo">
                                                <img src="https://multivac.com/content/experience-fragments/multivac-cms/pt/pt/site/header/master/_jcr_content/root/header/logo.coreimg.svg/1739187950553/logo-multivac-blue.svg" alt="">
                                            </div>
                                        </div>
                                        <label class="label_name m-0">MultiVac</label>
                                    </div>
                                    <div class="btn small-form-btn bar-code pointer mt-0"><i class="uis uis-search fs-12"></i></div>
                                </div>
                                <div class="col-sm-12 p-0">
                                    <div class="form-control bor-dash text-center">
                                        <p>Equipment supplier</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-xl-4 col-xxl-3 col-sm-12 col-12 mb-4 p-lr-0-sm">
                        <div class="card">
                            <div class="card-body p-3">
                                <div class="col-sm-12 dis-flex flex-sb p-0 mb-3">
                                    <div class="dis-flex flex-m">
                                        <div class="sidebar-cat-icon dis-flex flex-m flex-c">
                                            <div class="brand_logo">
                                                <img src="https://cdn.cookielaw.org/logos/bd2b6649-25e7-4d40-b3d1-fc7779e0599d/019192bb-5bfe-73db-b134-4eec70519d55/11899f4d-64d1-42a1-ab23-5911fd60c1b2/SVG__Master_Logo_RGB_Colour.png" alt="">
                                            </div>
                                        </div>
                                        <label class="label_name m-0">Storaenso</label>
                                    </div>
                                    <div class="btn small-form-btn bar-code pointer mt-0"><i class="uis uis-search fs-12"></i></div>
                                </div>
                                <div class="col-sm-12 p-0">
                                
                                    <div class="form-control bor-dash text-center">
                                        <p>Packaging supplier</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-xl-4 col-xxl-3 col-sm-12 col-12 mb-4 p-lr-0-sm">
                        <div class="card">
                            <div class="card-body p-3">
                                <div class="col-sm-12 dis-flex flex-sb p-0 mb-3">
                                    <div class="dis-flex flex-m">
                                        <div class="sidebar-cat-icon dis-flex flex-m flex-c">
                                            <div class="brand_logo">
                                                <img src="https://iocopackaging.com/wp-content/uploads/2023/09/ioco_Logo-Positive-1-1.svg" alt="">
                                            </div>
                                        </div>
                                        <label class="label_name m-0">ioco Packaging</label>
                                    </div>
                                    <div class="btn small-form-btn bar-code pointer mt-0"><i class="uis uis-search fs-12"></i></div>
                                </div>
                                <div class="col-sm-12 p-0">
                                
                                    <div class="form-control bor-dash text-center">
                                        <p>Packaging supplier</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-xl-4 col-xxl-3 col-sm-12 col-12 mb-4 p-lr-0-sm">
                        <div class="card">
                            <div class="card-body p-3">
                                <div class="col-sm-12 dis-flex flex-sb p-0 mb-3">
                                    <div class="dis-flex flex-m">
                                        <div class="sidebar-cat-icon dis-flex flex-m flex-c">
                                            <div class="brand_logo">
                                                <img src="https://www.dssmith.com/Static/dist/gfx/ds-logo-color.svg" alt="">
                                            </div>
                                        </div>
                                        <label class="label_name m-0">DS Smith</label>
                                    </div>
                                    <div class="btn small-form-btn bar-code pointer mt-0"><i class="uis uis-search fs-12"></i></div>
                                </div>
                                <div class="col-sm-12 p-0">
                                
                                    <div class="form-control bor-dash text-center">
                                        <p>Packaging supplier</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>
.suppliers_menu {
    padding-top: 2rem;

    .sidebar-cat-icon {
        width: 32px;
        height: 32px;
        margin-right: 0.7rem;
        border-radius: 0.4rem;
        box-shadow: 0 0.25rem 0.375rem -0.0625rem hsla(0deg, 0%, 8%, 0.12), 0 0.125rem 0.25rem -0.0625rem hsla(0deg, 0%, 8%, 0.07);
        padding: .1rem;

        .brand_logo {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            img {
                width: 100%;
            }
        }
    }

    .label_name {
        text-transform: uppercase;
        font-weight: 700;
    }

    .small-form-btn {
        display: flex!important;
        align-items: center!important;
        justify-content: center!important;
        max-height: 20px;
        padding: .2rem .65rem;
    }

    .form-control {
        color: var(--cl-text-extend);
    }
}
</style>